document.addEventListener("DOMContentLoaded", function () {
  if (window.themeVariables?.settings?.cartType !== 'notification') return;

  let lastAddedProduct = null;
  let cartState = null;

  // Fetch initial cart state
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      cartState = cart;
      if (cart.items.length > 0) {
        const firstItem = cart.items[0];
        lastAddedProduct = {
          title: firstItem.product_title,
          image: firstItem.image,
          price: firstItem.price
        };
      }
    });

  // Add to cart handler
  document.querySelectorAll('form[action^="/cart/add"]').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json'
        },
        body: formData
      })
        .then(() => {
          return fetch('/cart.js');
        })
        .then(res => res.json())
        .then(cart => {
          cartState = cart;
          const lastItem = cart.items[cart.items.length - 1];
          lastAddedProduct = {
            title: lastItem.product_title,
            image: lastItem.image,
            price: lastItem.price
          };
          window.scrollTo({ top: 0, behavior: 'smooth' });
          showCartNotification(lastAddedProduct);
        });
    });
  });

  // Show cart notification
  function showCartNotification(productOrMessage) {
    const notificationContainer = document.getElementById('shopify-section-cart-notification-popover');
    const notification = document.getElementById('cart-notification');
    const content = document.getElementById('cart-notification-content');

    let contentHtml = '';

    if (typeof productOrMessage === 'string') {
      contentHtml = `<p>${productOrMessage}</p>`;
    } else {
      const priceInCents = productOrMessage.variant_price
        || productOrMessage.price
        || productOrMessage.original_price
        || productOrMessage.final_price
        || (productOrMessage.variant && productOrMessage.variant.price);

      const formattedPrice = priceInCents
        ? (priceInCents / 100).toLocaleString('en-US', {
            style: 'currency',
            currency: window.Shopify.currency.active || 'USD',
          })
        : 'Price unavailable';

      contentHtml = `
        <div class="popup-cart-content-wrapper">
          <img src="${productOrMessage.image}"/>
          <div class="popup-cart-content">
            <p class="title">${productOrMessage.title}</p>
            <p class="price">${formattedPrice}</p>
          </div>
        </div>
      `;
    }

    content.innerHTML = contentHtml;
    notification.classList.add('show');
    notificationContainer.classList.add('show');

    // Close when clicking outside
    function handleOutsideClick(event) {
      if (!notification.contains(event.target) && !event.target.closest('.header__icon-wrapper')) {
        notification.classList.remove('show');
        notificationContainer.classList.remove('show');
        document.removeEventListener('click', handleOutsideClick);
      }
    }

    setTimeout(() => {
      document.addEventListener('click', handleOutsideClick);
    }, 50);
  }

  // Cart icon click handler
  const cartIcon = document.querySelector('a[href="/cart"].header__icon-wrapper');
  if (cartIcon) {
    cartIcon.addEventListener('click', function (e) {
      e.preventDefault();

      const notificationContainer = document.getElementById('shopify-section-cart-notification-popover');
      const notification = document.getElementById('cart-notification');
      const content = document.getElementById('cart-notification-content');

      if (notificationContainer.classList.contains('show')) {
        notification.classList.remove('show');
        notificationContainer.classList.remove('show');
        return;
      }

      if (lastAddedProduct) {
        showCartNotification(lastAddedProduct);
      } else if (cartState && cartState.items.length > 0) {
        const fallback = cartState.items[0];
        showCartNotification({
          title: fallback.product_title,
          image: fallback.image,
          price: fallback.price
        });
      } else {
        showCartNotification('Your bag is currently empty.');
      }
    });
  }
//   const wishlistIcon = document.querySelector('.header__icon-wrapper.tap-area.wishlist_icon');
// if (wishlistIcon) {
//   wishlistIcon.addEventListener('click', function () {
//     const notificationContainer = document.getElementById('shopify-section-cart-notification-popover');
//     const notification = document.getElementById('cart-notification');

//     if (notificationContainer && notificationContainer.classList.contains('show')) {
//       notificationContainer.classList.remove('show');
//     }
//     if (notification && notification.classList.contains('show')) {
//       notification.classList.remove('show');
//     }
//   });
// }

  const selectorsToCloseCartNotification = [
  '.header__icon-wrapper.tap-area.wishlist_icon',
  '.header__icon-wrapper.tap-area.hd-pocket.hd-lap'
];

selectorsToCloseCartNotification.forEach(selector => {
  const el = document.querySelector(selector);
  if (el) {
    el.addEventListener('click', function () {
      const notificationContainer = document.getElementById('shopify-section-cart-notification-popover');
      const notification = document.getElementById('cart-notification');

      if (notificationContainer?.classList.contains('show')) {
        notificationContainer.classList.remove('show');
      }
      if (notification?.classList.contains('show')) {
        notification.classList.remove('show');
      }
    });
  }
});

});




// document.addEventListener("DOMContentLoaded", function () {
//   const buttons = document.querySelectorAll("product-item__quick-buy-button");

//   buttons.forEach((button) => {
//     button.addEventListener("click", function (e) {
//       const wasActive = this.disabled; // Check BEFORE the DOM updates

//       const product = {
//         id: this.dataset.id,
//         title: this.dataset.title,
//         url: this.dataset.url,
//         image: this.dataset.image,
//         price: this.dataset.price,
//       };

//       let cart =
//         JSON.parse(localStorage.getItem("cartProducts")) || [];
//       const index = cart.findIndex((p) => p.id === product.id);

//       if (!wasActive) {
//         // ❌ Removing from cart
//         if (index !== -1) {
//           cart.splice(index, 1);
//           localStorage.setItem("cartProducts", JSON.stringify(cart));
//           updateCartPopup();
//         }
//         // Do not show popup
//       } else {
//         // ✅ Adding to cart
//         if (index === -1) {
//           cart.push(product);
//           localStorage.setItem("cartProducts", JSON.stringify(cart));
//         }
//         // ⬆️ Scroll to top
//         window.scrollTo({ top: 0, behavior: "smooth" });

//         // 🚫 Disable body scroll
//         document.body.style.overflow = "hidden";

//         showCartPopup(); // Show popup on add only
//       }
//     });
//   });

//   // Always show popup on cart icon click
//   const cartIcon = document.querySelector(
//     ".header__icon-wrapper.tap-area.cart_icon"
//   );
//   if (cartIcon) {
//     cartIcon.addEventListener("click", function (e) {
//       const popup = document.getElementById("cart-popup");

//       if (popup.style.display === "flex") {
//         // If visible → hide it and enable scroll
//         popup.style.display = "none";
//         document.body.style.overflow = "";
//       } else {
//         // If hidden → show it and disable scroll
//         showCartPopup();
//         document.body.style.overflow = "hidden";
//       }
//     });
//   }

//   // Close popup
//   const closeCartBtn = document.querySelector(".close-cart-popup");
//   if (closeCartBtn) {
//     closeCartBtn.addEventListener("click", function () {
//       document.getElementById("cart-popup").style.display = "none";
//       document.body.style.overflow = "";
//     });
//   }
// });

// function showCartPopup() {
//   const popup = document.getElementById("cart-popup");
//   popup.style.display = "flex";
//   updateCartPopup();
// }

// function updateCartPopup() {
//   const list = document.getElementById("cart-list");
//   const cart = JSON.parse(localStorage.getItem("cartProducts")) || [];

//   list.innerHTML = "";

//   if (cart.length === 0) {
//     list.innerHTML = "<li>Bag is empty.</li>";
//   } else {
//     cart.forEach((item) => {
//       const li = document.createElement("li");
//       li.innerHTML = `
//           <a href="${
//             item.url
//           }" style="display: flex; align-items: center; gap: 10px; text-decoration: none; color: inherit;">
//             <img src="${item.image}" alt="${
//         item.title
//       }" style="width: 50%; height: auto; object-fit: contain;">
//             <div>
//               <div style="font-weight: 500;">${item.title}</div>
//               <div style="font-size: 14px; color: #666;">${
//                 item.price || ""
//               }</div>
//             </div>
//           </a>
//         `;
//       list.appendChild(li);
//     });
//   }
// }
